export const DEFAULT_MODEL_ID = "2106935752"; // 2026 model

export const LEGACY_2025_MODEL_IDS = new Set(["1954172446", "827938453"]);

